// src/telas/menu/index.tsx

import styles from "./styles.module.css";
import logo from "../../assets/icon.png";
import Hamburger from "hamburger-react";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";

type DropdownItem = { label: string; to: string };

function NavDropdown({
  label,
  items,
  currentPath,
}: {
  label: string;
  items: DropdownItem[];
  currentPath: string;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const hasActiveChild = items.some((item) => item.to === currentPath);

  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div ref={ref} className={styles.dropdownContainer}>
      <button
        className={`${styles.navBtn} ${hasActiveChild ? styles.navBtnActive : ""}`}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        {label}
        <FaChevronDown
          size={11}
          className={`${styles.chevron} ${open ? styles.chevronOpen : ""}`}
        />
      </button>

      {open && (
        <div className={styles.dropdown}>
          {items.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`${styles.dropdownItem} ${item.to === currentPath ? styles.dropdownItemActive : ""}`}
              onClick={() => setOpen(false)}
            >
              {item.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export function Menu() {
  const [isOpen, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <header className={styles.menu}>
        {/* Logo */}
        <Link to="/home" className={styles.logoLink}>
          <img alt="logo" src={logo} className={styles.logo} />
        </Link>

        {/* Desktop nav */}
        <nav className={styles.actions}>
          <button
            className={`${styles.navBtn} ${styles.navBtnPrimary} ${isActive("/home") ? styles.navBtnPrimaryActive : ""}`}
            onClick={() => navigate("/home")}
          >
            Pagamentos
          </button>

          <NavDropdown
            label="Serviços"
            currentPath={location.pathname}
            items={[
              { label: "Buscar Serviços", to: "/servicos" },
              { label: "Meus Serviços",   to: "/meus-servicos" },
            ]}
          />

          <NavDropdown
            label="Cadastros"
            currentPath={location.pathname}
            items={[
              { label: "Técnicos", to: "/tecnicos" },
              { label: "Insumos",  to: "/insumos" },
              { label: "Praças",   to: "/pracas" },
            ]}
          />

          <Link
            to="/minha-conta"
            className={`${styles.navLink} ${isActive("/minha-conta") ? styles.navLinkActive : ""}`}
          >
            Minha Conta
          </Link>

          <Link to="/" className={styles.navLinkExit}>
            Sair
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <div className={styles.hamburger}>
          <Hamburger toggled={isOpen} toggle={setOpen} size={22} />
        </div>
      </header>

      {/* Mobile drawer */}
      {isOpen && (
        <nav className={styles.mobileMenu} onClick={() => setOpen(false)}>
          <Link to="/home"         className={styles.mobileItem}>Home</Link>
          <Link to="/servicos"     className={styles.mobileItem}>Buscar Serviços</Link>
          <Link to="/meus-servicos" className={styles.mobileItem}>Meus Serviços</Link>
          <Link to="/tecnicos"     className={styles.mobileItem}>Técnicos</Link>
          <Link to="/insumos"      className={styles.mobileItem}>Insumos</Link>
          <Link to="/pracas"       className={styles.mobileItem}>Praças</Link>
          <Link to="/minha-conta"  className={styles.mobileItem}>Minha Conta</Link>
          <Link to="/"             className={`${styles.mobileItem} ${styles.mobileItemExit}`}>Sair</Link>
        </nav>
      )}
    </>
  );
}